import React from 'react';
export const History = React.lazy(() => import('./History.jsx'));